import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import * as React from 'react';
import { developmentDiagnosticsEnabled } from '../../../lib/diagnostics';
import { cn } from '../../../lib/utils';
import { SpecraHeading, SpecraText } from '../ensigns/typography';
import { SpecraTimelineItem } from '../lieutenants/timeline-item';
function renderEntries(items, o) {
    if (developmentDiagnosticsEnabled && (o.selectedId !== undefined || o.onItemSelect) && items.some((item)=>!item.id)) {
        console.warn('SpecraTimeline: entries need an id when selectedId/onItemSelect are used');
    }
    return items.map((item, index)=>/*#__PURE__*/ _createElement(SpecraTimelineItem, {
            ...item,
            ...o.getItemProps?.(item),
            "data-item-id": item.id,
            "data-testid": o.getItemTestId?.(item),
            key: item.id ?? `${String(item.title)}-${index}`,
            last: index === items.length - 1,
            onSelect: item.onSelect ?? (o.onItemSelect && item.id ? ()=>o.onItemSelect?.(item.id) : undefined),
            renderLink: item.renderLink ?? o.renderLink,
            selected: item.selected ?? (o.selectedId !== undefined && item.id === o.selectedId),
            variant: item.variant ?? o.variant
        }));
}
function TimelineGroup({ group, options, testId }) {
    const id = React.useId();
    return /*#__PURE__*/ _jsxs("section", {
        "aria-labelledby": id,
        "data-group-id": group.id,
        "data-testid": testId,
        children: [
            /*#__PURE__*/ _jsx(SpecraHeading, {
                as: "h3",
                className: "border-b border-foreground pb-[var(--space-1-5)] pt-[var(--space-2-5)]",
                id: id,
                size: "sm",
                children: group.label
            }),
            /*#__PURE__*/ _jsx("ol", {
                className: "m-0 list-none p-0",
                children: renderEntries(group.items, options)
            })
        ]
    });
}
/** Chronological collection for modifications, periods, record history, threads and versions. */ export function SpecraTimeline({ className, emptyText, getGroupTestId, getItemProps, getItemTestId, groups, items, onItemSelect, renderLink, selectedId, variant = 'rail', ...props }) {
    const options = {
        variant,
        renderLink,
        selectedId,
        onItemSelect,
        getItemProps,
        getItemTestId
    };
    const empty = groups ? groups.every((g)=>g.items.length === 0) : !items || items.length === 0;
    if (empty) {
        return emptyText ? /*#__PURE__*/ _jsx(SpecraText, {
            as: "p",
            size: "body-sm",
            tone: "muted",
            children: emptyText
        }) : null;
    }
    if (groups) {
        return /*#__PURE__*/ _jsx("div", {
            className: cn('flex flex-col gap-[var(--space-4)]', className),
            ...props,
            children: groups.map((group)=>/*#__PURE__*/ _jsx(TimelineGroup, {
                    group: group,
                    options: options,
                    testId: getGroupTestId?.(group)
                }, group.id))
        });
    }
    return /*#__PURE__*/ _jsx("ol", {
        className: cn('m-0 list-none p-0', className),
        ...props,
        children: renderEntries(items ?? [], options)
    });
}
